import { Card, CardActions, CardContent, CardMedia } from "@mui/material"
import { FC } from "react"
import { Link } from "react-router-dom"

import { getLinkFromEvent } from "@utils/event.link.utils"
import { Participant } from "src/shared/events-feed/slice/types"
import eventPhoto from "../../../app/data/avatarUrl"

import { Row } from "@/components/index"
import SimpleSharedDialog from "@components/Dialogs/SimpleSharedDialog"
import CardBadge from "../components/CardBadge"
import CardDescription from "../components/CardDescription"
import CardDivider from "../components/CardDivider"
import CardTitle from "../components/CardTitle"
import FavoritesButton from "../components/FavoritesButton"
import InfoLabel from "../components/InfoLabel"
import ParticipantsAvatarRow from "../components/ParticipantsAvatarRow"
import WalletIconStyled from "../components/WalletIconStyled"

import CalendarIconCard from "@/assets/svg/card-icons-pack/calendar-icon.svg?react"
import ClockIconCard from "@/assets/svg/card-icons-pack/clock-icon.svg?react"
import LocationIconCard from "@/assets/svg/card-icons-pack/location-icon.svg?react"
import FallbackImg from "@/assets/svg/profile/FallbackImg.svg"
import { card, cardContent, cardImg } from "./styles"


export type FavoriteItemProps = {
  id: number
  disabled?: boolean
  img: string
  location: string
  calendar?: string
  time: string
  title: string
  description: string
  category?: string
  isRemove?: boolean
  price?: number
  participants?: Participant[]
}

const FavoriteItem: FC<FavoriteItemProps> = ({
  img,
  title,
  description,
  location,
  time,
  price,
  id,
  participants,
}) => {

  const dateFormatter = new Intl.DateTimeFormat("ru", {
    year: "numeric",
    month: "long",
    day: "numeric",
  })
  const timeFormatter = new Intl.DateTimeFormat("ru", {
    hour: "numeric",
    minute: "numeric",
  })


  return (
    <Card sx={card}>
      <Link to={`/fid/${id}`}>
        <CardMedia
          image={eventPhoto(img) || FallbackImg}
          title={title}
          sx={cardImg}
        >
          <CardBadge time={time} />
          <FavoritesButton id= {id} isFavorite />
          {price && <WalletIconStyled />}
        </CardMedia>
      </Link>
      <CardContent sx={cardContent}>
        <Row>
          <Link to={`/fid/${id}`}>
            <CardTitle title={title} />
          </Link>
          <SimpleSharedDialog sharedLink={getLinkFromEvent(id)} />
        </Row>
        <InfoLabel text={location} LeftIcon={LocationIconCard} />
        <Row justifyContent="start" gap={14}>
          <InfoLabel
            text={dateFormatter.format(new Date(Date.parse(time)))}
            LeftIcon={CalendarIconCard}
          />
          <InfoLabel
            text={timeFormatter.format(new Date(Date.parse(time)))}
            LeftIcon={ClockIconCard}
          />
        </Row>
        <CardDivider />
        <Link to={`/fid/${id}`}>
          <CardDescription text={description} />
        </Link>
      </CardContent>
      <CardActions>
        <ParticipantsAvatarRow participants={participants} maxCount={5} />
      </CardActions>
    </Card>
  )
}

export default FavoriteItem
